import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const RotateLeadsIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "RotateLeads",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M9.85 14.83v.2c0 1.89.62 3.64 1.66 5.06l-.02-.02c.63.91 1.65 1.51 2.81 1.57 1.17-.06 2.18-.66 2.81-1.56a8.55 8.55 0 0 0 1.64-5.03v-.23c0-2.45-1.99-4.44-4.45-4.44s-4.45 1.99-4.45 4.45m19.82-3.64a1.27 1.27 0 0 0-1.37-.36s-2.03.67-2.03.67l-.48.16c-1.8-4.69-6.28-7.96-11.51-7.96-6.79 0-12.3 5.51-12.3 12.3S7.3 28.12 13.94 28.3h.5c.28 0 .57 0 .86-.05h.1c1.06-.09 2.03-.3 2.95-.62l-.09.03c.35-.12.7-.26 1.04-.41l.07-.04a5.5 5.5 0 0 0 2.45-2.06v-.02c.2-.25.31-.56.31-.9 0-.29-.08-.56-.22-.79-.06-.15-.14-.28-.24-.4s-.06-.04-.06-.04a9.592 9.592 0 0 0-3.19-2.38l-.06-.03c-.87 1.38-2.35 2.31-4.05 2.39h-.01a5.06 5.06 0 0 1-4.05-2.33v-.02a9.9 9.9 0 0 0-3.28 2.42c-.11.13-.2.28-.26.43a10.57 10.57 0 0 1-3.02-7.42c0-5.88 4.77-10.65 10.65-10.65 4.5 0 8.34 2.79 9.9 6.73l.03.07-.36.13-1.95.66c-.52.17-.89.64-.89 1.21 0 .51.3.94.73 1.15s4.28 2.11 4.28 2.11a1.271 1.271 0 0 0 1.69-.56s2.1-4.29 2.1-4.29c.08-.17.14-.36.14-.57 0-.33-.12-.62-.32-.85Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M13.6 18.86c-2.5 0-4.54-2.04-4.54-4.54s2.04-4.54 4.54-4.54 4.54 2.04 4.54 4.54-2.04 4.54-4.54 4.54m0-6.8c-1.24 0-2.26 1.01-2.26 2.26s1.01 2.26 2.26 2.26 2.26-1.01 2.26-2.26-1.01-2.26-2.26-2.26"
      }), /*#__PURE__*/_jsx("path", {
        d: "M7.91 28.95c-.17 0-.35-.04-.51-.12A13.67 13.67 0 0 1-.14 16.57c0-7.56 6.15-13.71 13.71-13.71s13.72 6.15 13.72 13.72v6.81a1.14 1.14 0 1 1-2.28 0v-6.81c0-6.3-5.13-11.43-11.43-11.43S2.14 10.27 2.14 16.57c0 3.79 1.84 7.25 4.89 9.38.81-2.87 3.45-4.98 6.57-4.98 3.77 0 6.83 3.06 6.83 6.83a1.14 1.14 0 1 1-2.28 0c0-2.5-2.04-4.54-4.54-4.54S9.07 25.3 9.07 27.8c0 .4-.21.77-.54.98-.18.11-.4.17-.61.17Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M26.15 24.53c-.29 0-.58-.11-.81-.33l-4.56-4.56a1.14 1.14 0 0 1 0-1.62 1.14 1.14 0 0 1 1.62 0l3.75 3.75 3.75-3.75a1.14 1.14 0 0 1 1.62 0c.45.45.45 1.17 0 1.62l-4.56 4.56c-.22.22-.52.33-.81.33"
      })]
    })
  }));
};
RotateLeadsIcon.displayName = 'RotateLeadsIcon';